import { render } from "./PanelsDemo.vue?vue&type=template&id=e8ba2e06&scoped=true"
import script from "./PanelsDemo.vue?vue&type=script&lang=js"
export * from "./PanelsDemo.vue?vue&type=script&lang=js"

import "./PanelsDemo.vue?vue&type=style&index=0&id=e8ba2e06&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ba2e06"]])

export default __exports__